<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import PayrollForm from '@/components/salary/PayrollForm.vue';
    import { useI18n } from 'vue-i18n';
    import QueryKey from '@/enums/QueryKey';
    import { today, getLocalTimeZone } from '@internationalized/date';
    import { toast } from 'vue-sonner';

    defineProps<{
        selectedCompanyId: number;
    }>();

    const { t } = useI18n();

    const currentDate = today(getLocalTimeZone());

    const form = useForm({
        type: 'primary',
        month: currentDate.month,
        year: currentDate.year,
        employeeIds: [],
    });

    const handleError = (error: any) => {
        if (error.info) {
            toast.success(error.info);
        } else {
            toast.error(t('forms.generic_error'));
        }
    };
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.salary.payrolls.store')"
        :query-key="[QueryKey.PAYROLLS, selectedCompanyId]"
        title="salary.payroll.create"
        button-text="salary.payroll.create"
        submit-text="salary.payroll.start"
        success-message="payrolls.edit.created_success"
        hide-error-toast
        @error="handleError"
    >
        <PayrollForm
            :form="form"
            :selected-company-id="selectedCompanyId"
        />
    </DialogForm>
</template>
